export enum ScreeningProgress {
  NOT_SCREENED = "NOT_SCREENED",
  POTENTIAL_MATCH = "POTENTIAL_MATCH",
  SCREENED_ACCEPTED = "SCREENED_ACCEPTED",
  SCREENED_DECLINED = "SCREENED_DECLINED",
}
